/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown> }} Endpoint_Other_HeadingInputs */

const en_endpoint_other_heading = /** @type {(inputs: Endpoint_Other_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Other ${i?.platform} endpoints`)
};

const zh_hans1_endpoint_other_heading = /** @type {(inputs: Endpoint_Other_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.platform} 的其他接口`)
};

const pt_br2_endpoint_other_heading = /** @type {(inputs: Endpoint_Other_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Outros endpoints de ${i?.platform}`)
};

const es_endpoint_other_heading = /** @type {(inputs: Endpoint_Other_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Otros endpoints de ${i?.platform}`)
};

const fr_endpoint_other_heading = /** @type {(inputs: Endpoint_Other_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Autres endpoints ${i?.platform}`)
};

const de_endpoint_other_heading = /** @type {(inputs: Endpoint_Other_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weitere ${i?.platform}-Endpoints`)
};

const ru_endpoint_other_heading = /** @type {(inputs: Endpoint_Other_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Другие эндпоинты ${i?.platform}`)
};

const it_endpoint_other_heading = /** @type {(inputs: Endpoint_Other_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Altri endpoint di ${i?.platform}`)
};

/**
* | output |
* | --- |
* | "Other {platform} endpoints" |
*
* @param {Endpoint_Other_HeadingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_other_heading = /** @type {((inputs: Endpoint_Other_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Other_HeadingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_other_heading(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_other_heading(inputs)
	if (locale === "es") return es_endpoint_other_heading(inputs)
	if (locale === "fr") return fr_endpoint_other_heading(inputs)
	if (locale === "de") return de_endpoint_other_heading(inputs)
	if (locale === "ru") return ru_endpoint_other_heading(inputs)
	if (locale === "it") return it_endpoint_other_heading(inputs)
	return en_endpoint_other_heading(inputs)
});